import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import {
  AssignmentOutlined as AssignmentOutlinedIcon,
  SavingsOutlined as SavingsOutlinedIcon,
  TrendingUpOutlined as TrendingUpOutlinedIcon,
} from "@mui/icons-material";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { useContextProdutor } from "src/Contexts/produtores/ProdutoresContext";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { UseGetByIdProducer } from "../components/TableProducer/hooks/UseGetByIdProducer";
import { HeaderInternalProducer } from "./components/HeaderInternalProducer";
import { MetricCard } from "../../../../components/MetricCard/MetricCard";
import { TabAcessoOnline } from "./components/tabs/TabAcessoOnline";
import { TabContaCorrente } from "./components/tabs/TabContaCorrente";
import { TabInformacoes } from "./components/tabs/TabInformacoes";
import { useCurrentBalanceProducer } from "./hooks/useCurrentBalanceProducer";
import { useProducerProducaoProdutor } from "./hooks/useProducerProducaoProdutor";

export const ProducerInternal = () => {
  const { id } = useParams();
  const { valuesInputsProdutor } = useContextProdutor();
  const { handleGetById } = UseGetByIdProducer();
  const [tab, setTab] = useState("informacoes");

  const {
    currentBalance,
    loadingCurrentBalance,
    handleGetCurrentBalance,
  } = useCurrentBalanceProducer();
  const {
    totalMensalidadeValue,
    totalVidas,
    totalContratos,
    loadingProducao,
    handleGetProducaoProdutor,
  } = useProducerProducaoProdutor();

  useEffect(() => {
    if (!id) return;
    handleGetById(id);
    handleGetCurrentBalance(id);
    handleGetProducaoProdutor(id);
  }, [id]);

  if (!id) return null;

  const isProducerLoaded =
    valuesInputsProdutor.id_tenant === id || valuesInputsProdutor.id === id;

  if (!isProducerLoaded) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: { xs: 2, md: 3 },
        p: { xs: 1, sm: 1, md: 2 },
        minHeight: "100vh",
      }}
    >
      <HeaderInternalProducer />

      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={4}>
          <MetricCard
            title="Total Produção"
            value={
              loadingProducao
                ? "Carregando..."
                : `R$ ${totalMensalidadeValue < 0 ? "-" : ""} ${FormatMoney(
                  String(Math.abs(totalMensalidadeValue).toFixed(2))
                )} `
            }
            subtitle={`Quantidade: ${totalContratos} contratos (Vidas: ${totalVidas})`}
            color="#22c55e"
            icon={<TrendingUpOutlinedIcon sx={{ fontSize: 16 }} />}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <MetricCard
            title="Média de produção"
            value={
              loadingProducao
                ? "Carregando..."
                : `R$ ${totalMensalidadeValue < 0 ? "-" : ""} ${FormatMoney(String(Math.abs(totalMensalidadeValue / totalContratos).toFixed(2)))}`
            }
            subtitle={`Média de produção por contrato`}
            color="#7c3aed"
            icon={<AssignmentOutlinedIcon sx={{ fontSize: 16 }} />}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <MetricCard
            title="Saldo Conta Corrente"
            value={
              loadingCurrentBalance
                ? "Carregando..."
                : `R$ ${currentBalance < 0 ? "-" : ""} ${FormatMoney(
                  String(Math.abs(currentBalance).toFixed(2))
                )}`
            }
            subtitle={currentBalance < 0 ? "Saldo negativo" : "Disponivel"}
            color={currentBalance < 0 ? "#dc2626" : "#16a34a"}
            icon={<SavingsOutlinedIcon sx={{ fontSize: 16 }} />}
          />
        </Grid>
      </Grid>

      <TabContext value={tab}>
        <Tabs
          value={tab}
          onChange={(_, newValue) => setTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            backgroundColor: "#F5F7FA",
            borderRadius: "10px",
            minHeight: 40,
          }}
        >
          <Tab label="Informacoes" value="informacoes" sx={{ minHeight: 40 }} />
          <Tab label="Conta Corrente" value="conta-corrente" sx={{ minHeight: 40 }} />
          <Tab label="Acesso Online" value="acesso" sx={{ minHeight: 40 }} />
        </Tabs>

        <TabPanel value="informacoes" sx={{ p: 0 }}>
          <TabInformacoes />
        </TabPanel>

        <TabPanel value="conta-corrente" sx={{ p: 0 }}>
          <TabContaCorrente />
        </TabPanel>

        <TabPanel value="acesso" sx={{ p: 0 }}>
          <TabAcessoOnline />
        </TabPanel>
      </TabContext>
    </Box>
  );
};
